import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const appRoot = document.getElementById('appRoot');
    if (appRoot) {
      appRoot.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}